import { BrowserModule , Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgBootstrapFormValidationModule } from '@mingleats/ng-bootstrap-form-validation';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AlertComponent } from './components/alert/alert.component';

import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { SharedService } from './shared/sharedservice';

import { ErrorInterceptor } from './helpers/error.interceptor';
import { AuthInterceptor } from './helpers/auth.interceptor';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderInterceptorService } from './helpers/loader.interceptor';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogService } from './services/confirm-dialog.service';
import { VerificationComponent } from './components/verification/verification.component';
import { FaqComponent } from './components/faq/faq.component';
import { WhyGovtTowAuctionComponent } from './components/whygovttowauction/whygovttowauction.component';
import { PrivacypolicyComponent } from './components/privacypolicy/privacypolicy.component';
import { TncComponent } from './components/tnc/tnc.component';
import { NgxSelectModule } from 'ngx-select-ex';

import { FullCalendarModule } from '@fullcalendar/angular';
import { AuctionSchedulerComponent } from './components/auction-scheduler/auction-scheduler.component'; // a plugin!
import {MatExpansionModule} from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon'; // Import MatIconModule
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { BidHistoryDialogComponent } from './components/bid-history-dialog/bid-history-dialog.component';
import { SharedModule } from './shared/shared.module';
import { RemovebidderaccountComponent } from './components/removebidderaccount/removebidderaccount.component';
// Rollback reference: import {AppUserSharedModule} from '../../admin/src/app/app.module';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AlertComponent,
    LoaderComponent,
    ConfirmDialogComponent,
    VerificationComponent,
    FaqComponent,
    WhyGovtTowAuctionComponent,
    PrivacypolicyComponent,
    TncComponent,
    AuctionSchedulerComponent, 
    BidHistoryDialogComponent, RemovebidderaccountComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatExpansionModule,
    SharedModule,
    CoreModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    }),
    NgBootstrapFormValidationModule.forRoot(),
    // DeviceDetectorModule.forRoot(), not used
    NgxSpinnerModule,
    NgbModule,
     //Ng5SliderModule,
     ModalModule.forRoot(),
    // Rollback reference: AppUserSharedModule.forRoot(),
    NgxSelectModule,
    FullCalendarModule,
    MatIconModule
    , MatStepperModule
    , MatInputModule
  ], 
  providers: [
    
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    SharedService,
    BsModalRef,
    ConfirmDialogService,
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
